import { useEffect } from "react";
import { Link } from "react-router-dom";
import { SEOHead } from "@/components/SEOHead";

const MarketingForm = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://api.zappages.de/js/form_embed.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-neutral-50 flex flex-col items-center justify-center py-12">
      <SEOHead
        title="Kundenbewertung & Feedback — Easy Umzug"
        description="Bitte nehmen Sie sich kurz Zeit für unser Feedback-Formular. Ihre Meinung hilft uns, unseren Service zu verbessern."
        canonical="https://easy-umzugsservice.de/marketing-form"
      />
      
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="flex flex-col items-center mb-8">
          <Link to="/" className="transition-transform hover:scale-105 duration-300">
            <img 
              src="https://images.leadconnectorhq.com/image/f_webp/q_80/r_300/u_https://assets.cdn.filesafe.space/Zrqvy6cNzSbnzDV55cv1/media/6936d9b74b202f068ab37a46.png" 
              alt="Easy Umzug Logo" 
              className="h-16 w-auto"
            />
          </Link>
        </div>

        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-neutral-100">
          <iframe
            src="https://api.zappages.de/widget/form/ENNhS6vf4kqKwlm862r4"
            style={{ width: '100%', height: '872px', border: 'none', borderRadius: '4px' }}
            id="inline-ENNhS6vf4kqKwlm862r4" 
            data-layout="{'id':'INLINE'}"
            data-trigger-type="alwaysShow"
            data-trigger-value=""
            data-activation-type="alwaysActivated"
            data-activation-value=""
            data-deactivation-type="neverDeactivate"
            data-deactivation-value=""
            data-form-name="Kundenbewertung + 1 Jahr-Follow-up Formular "
            data-height="872"
            data-layout-iframe-id="inline-ENNhS6vf4kqKwlm862r4"
            data-form-id="ENNhS6vf4kqKwlm862r4"
            title="Kundenbewertung + 1 Jahr-Follow-up Formular "
          ></iframe>
        </div>
        
        <div className="mt-8 text-center text-sm text-neutral-400">
          <Link to="/datenschutz" className="hover:text-primary transition-colors">Datenschutzhinweise</Link>
          <span className="mx-2">|</span>
          <Link to="/impressum" className="hover:text-primary transition-colors">Impressum</Link>
        </div>
      </div>
    </div>
  );
};

export default MarketingForm;
